import referenceDate from "../reference-date";
import sortByDates from "../sort-by-dates";

export default function getRecentDay(
  date, // May be `null` for current date.
  items,
) {
  // Ensure chronologically ascending sort order.
  sortByDates(items);

  const reference = referenceDate(date);
  return items.reduce((acc, cur) => {
    // Keep only past items.
    if (new Date(cur.date) >= reference) {
      return acc;
    }

    // Return current item. We have already
    // sorted all items in chronological order.
    // -> Replace acc by cur until cur does not match any more.
    return cur;
  }, null);
}
